import { useState } from "react";
import SectionHeader from "./SectionHeader";
import { FAQ_ITEMS } from "@/lib/content";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-question-line" aria-hidden="true" />
            常见问题 FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            关于吃瓜，
            <br />
            你可能想问
          </h2>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            内容来源、隐私处理、更新节奏、投稿方式……这些大家最关心的问题，我们都放在了这里。
          </p>
          <div className="mt-6 rounded-xl border border-background-300/60 bg-background-100 p-4 text-sm text-foreground-700">
            <div className="flex items-center gap-2 font-medium text-foreground-900">
              <i className="ri-message-3-line text-accent-600" aria-hidden="true" />
              还有别的疑问？
            </div>
            <a href="mailto:hello@daxuechigua.example" className="mt-2 inline-flex items-center gap-1.5 text-primary-700 hover:text-primary-800">
              <i className="ri-mail-line" aria-hidden="true" />
              hello@daxuechigua.example
            </a>
          </div>
        </div>

        <div className="space-y-3 lg:col-span-3">
          {FAQ_ITEMS.map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl border transition-colors ${open ? "border-primary-300 bg-primary-50/50" : "border-background-300/60 bg-background-100"}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="flex items-center gap-3 font-heading text-[15px] font-bold text-foreground-950">
                    <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"}`}>
                      {i + 1}
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`ri-add-line text-xl text-foreground-600 transition-transform duration-300 ${open ? "rotate-45 text-primary-600" : ""}`}
                    aria-hidden="true"
                  />
                </button>
                {open && <p className="border-t border-primary-200/60 px-5 py-4 pl-14 text-sm leading-7 text-foreground-700">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}